import React from 'react';

export default function StatCard({
  label,
  value,
  hint,
}: {
  label: string;
  value: React.ReactNode;
  hint?: string;
}) {
  return (
    <div className="admin-billing-stat-card">
      <div className="admin-billing-stat-label">{label}</div>
      <div className="admin-billing-stat-value">{value}</div>
      {hint ? <div className="admin-billing-stat-hint">{hint}</div> : null}
    </div>
  );
}
